import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useWeeklyDashboardContext } from '../context';
import { format, getMonth } from 'date-fns';
import { GRADES_WITH_TBD } from '../constants/grades';
var useWeeklyStudentsTable = function (students) {
    var _a = useWeeklyDashboardContext().calendarData, days = _a.days, _b = _a.weekRange, startDate = _b[0], endDate = _b[1], isWeekInThePast = _a.isWeekInThePast;
    var tableHeaderRef = useRef(null);
    var isHeaderAtTheTop = useCheckHeaderPosition(tableHeaderRef);
    var groupedStudents = useMemo(function () {
        var result = groupBy(students, function (student) { return student.grade; });
        result.forEach(function (entry) { return entry.sort(sortStudents); });
        return Array.from(result.entries()).sort(sortGrades);
    }, [students]);
    var formattedWeekRange = getMonth(startDate) === getMonth(endDate)
        ? format(startDate, 'MMMM') + " " + format(startDate, 'd') + " \u2013 " + format(endDate, 'd')
        : format(startDate, 'MMMM d') + " \u2013 " + format(endDate, 'MMMM d');
    return {
        days: days,
        tableHeaderRef: tableHeaderRef,
        formattedWeekRange: formattedWeekRange,
        groupedStudents: groupedStudents,
        isHeaderAtTheTop: isHeaderAtTheTop,
        isWeekInThePast: isWeekInThePast,
    };
};
var useCheckHeaderPosition = function (ref) {
    var _a = useState(false), isHeaderAtTheTop = _a[0], setIsHeaderAtTheTop = _a[1];
    var checkTopPos = useCallback(function () {
        if (!ref.current)
            return;
        var top = ref.current.getBoundingClientRect().top;
        var topRowHeight = 40;
        if (top <= topRowHeight && isHeaderAtTheTop === false) {
            setIsHeaderAtTheTop(true);
        }
        else if (top > topRowHeight && isHeaderAtTheTop === true) {
            setIsHeaderAtTheTop(false);
        }
    }, [isHeaderAtTheTop, ref]);
    var ticking = useRef(false);
    var handleDocumentScroll = useCallback(function () {
        if (!ticking.current) {
            window.requestAnimationFrame(function () {
                checkTopPos();
                ticking.current = false;
            });
            ticking.current = true;
        }
    }, [checkTopPos]);
    useEffect(function () {
        document.addEventListener('scroll', handleDocumentScroll);
        return function () {
            document.removeEventListener('scroll', handleDocumentScroll);
        };
    }, [handleDocumentScroll]);
    return isHeaderAtTheTop;
};
function groupBy(list, keyGetter) {
    var map = new Map();
    list.forEach(function (item) {
        var key = keyGetter(item);
        var collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
}
var sortStudents = function (a, b) {
    return a.fullName.localeCompare(b.fullName);
};
var sortGrades = function (_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return GRADES_WITH_TBD.indexOf(a) - GRADES_WITH_TBD.indexOf(b);
};
export { useWeeklyStudentsTable };
